import { ELanguages } from "src/app/core/enums/Languages.enum";

export const locale = {
  lang: ELanguages.EN,
  data: {
    PINNED: {
      BUTTON: "Go to the card",
    },
    BUTTON: {
      SAVE: "Save",
      UPDATE: "Update",
      DELETE: "Delete",
      SEARCH: "Search ",
      CANCEL: "Cancel",
    },
    ACTION_DROPDOWN: {
      ACTION: "Actions",
      ADD: "Add",
      EDIT: "Edit",
      DELETE: "Delete",
      CONFORMATION: "Confirmation",
    },
    ACTION_DROPDOWN_FILE: {
      FILE: "File",
      PRINT: "Print",
      EXCEL: "Excel",
    },
    TRANSLATOR: {
      SELECT: "Choose language",
      WAITING: "Please wait...",
    },
    SELECT: {
      SELECT_COMPANY: "Select a company",
      NOT_FOUND: "Not Found",
    },
    DATAPICKER: {
      TITLE: "dd/mm/yyyy",
      FROM: "From:",
      TO: "To:",
    },
    NAVBAR: {
      CURRENT_PERIOD: "Current Period:",
    },
    MENU: {
      DASHBOARD: "Statistics",
      TOOLS: {
        TITLE: "Tools",
        RESIDENTS: "Residents",
        PAYMENTS: "Electronic payments",
        MUNIS: "Munis",
        APPEAL: "Apply online",
        NARYAD: "Outfit",
        OPERATIONS: "Period operations",
        PLANS: "Description",
        COURT_WARNING: "Court warning",
        COURT_ACTION: "Court proceedings",
        LIMITS: "Notice Limitations",
        MVD_INFO: "MVD information",
        KADASTR_INFO: "Cadastral data",
        ACTS: "Acts",
        ACT_FORMS: "Act forms",
        INVENT_ACTS: "Inventory acts",
        CHANGING_ACTS: "Acts of changing the number of residents",
        FROZEN_DEBT_ACTS: "Frozen Debt Acts",
        CASH_PAYMENTS: "Cash payments",
        ORG_EMPLOYEES: "Org employees",
        EMPLOYEES_ACTIONS: "Employee actions",
        USERS_SPECIAL_ACTIONS: "Users' special actions",
        RECEIPT_FORMS_COUNT: "Receipt forms count",
      },
      GENERAL: {
        TITLE: "General",
        ZONES: "Areas",
        RECEIPT_ISSUERS: "Issuers of receipts",
      },
      WORK1031: {
        TITLE: "Work under provision 1031",
        PAYMENT_LIST: "Work with the payment list",
        EMPLOYEE_LIST: "Work with the list of employees of the organization",
      },
      GEOGRAPHY: {
        TITLE: "Geography",
        VILLAGES: "Neighborhoods",
        STREETS: "Streets",
        REGIONS: "Regions",
        DISTRICTS: "Districts",
      },
      MANAGEMENT: {
        TITLE: "Control",
        ROLES: "User roles",
        USERS: "Users",
        COMPANY_OPERATIONS: "Enterprises period operations",
        REPORTING_PERIOD: " Reporting for current periods",
      },
      REPORTS: {
        TITLE: "Reports",
        REPORT1: "DHJ-1 Report",
        REPORT2: "F-2 DHJ Report",
        REPORT3: "Dxsh-2 list of receipts",
        REPORT4: "Analysis of debtors in the section of neighborhoods",
        REPORT5: "Munis Payments Report",
        REPORT6: "Analysis of rights holders in the section of neighborhoods",
        REPORT7: "EL.payment report",
        REPORT8: "Non-paying subscribers",
        REPORT9: "Notification Limitations Report",
        REPORT10: "Analysis of Khatlov documents",
        REPORT11: "Report of correspondence documents",
        REPORT12: "Periodic activity report on court proceedings",
        REPORT13: "Population report",
        REPORT14: "Online application report",
        REPORT15: "User session swod report",
        REPORT16: "Income statement etc",
        REPORT17: "User session report",
        REPORT18: "Subscribers with high debt",
        REPORT19:
          "A comprehensive report on subscribers with high indebtedness",
        REPORT20: "Income - in the section of employees",
        REPORT21: "Pinfl and Cadastre number completion report",
      },
      NOTIFICATIONS: {
        TITLE: "Notifications",
        MODULE: "Notification module",
        REQUIREMENTS: "Requirements",
      },
      GPS_TRACKING: {
        TITLE: "GPS kuzatuv",
        GPS: "GPS kuzatuv",
        MONITORING: "Avtomobillar monitoringi",
        ACTION_REPORT: "Harakatlar hisoboti",
      },
      LEGAL_ENTITIES: {
        TITLE: "Yuridik shaxslar",
        ORGANIZATIONS: "Tashkilotlar",
        MONEY_TRANSFERS: "Pul o'tkazmalari",
        ONLINE_PAYMENTS: "Elektron toʻlovlar",
        MUNIS: "Munis toʻlovlar",
        ACTS: "Aktlar",
        CASH_PAYMENTS: "Naqd pul toʻlovlari",
        SCHET_FAKTURA: "Schet-fakturalar",
      },
    },
    TOAST: {
      TITLE: {
        SUCCESS: "Done",
        WARNING: "Warning",
        ERROR: "Error",
        INFO: "Info",
      },
    },
    THEME_MODE: {
      LIGHT: "Light",
      DARK: "Dark",
      SYSTEM: "System",
    },
    HEADER_INPUT: {
      REGION: "Region",
      DISTRICTS: "District",
      COMPANY: "Company",
    },
    USER_INNER: {
      PROFILE: "Profile",
      EXIT: "Log out",
    },
    AUTH: {
      LOGIN: {
        TITLE: "Log in",
        BUTTON: "Enter",
        FORGOT_BUTTON: "Forgot password?",
        LABEL_LOGIN: "Login",
        LABEL_PASSWORD: "Password",
        PLACEHOLDER_LOGIN: "Enter your login",
        PLACEHOLDER_PASSWORD: "Enter your password",
        ERROR: "Incorrect data entered!",
      },
      FORGOT: {
        TITLE: "Forgot password?",
        DESC: "Enter your email to reset your password",
        SUCCESS: "Your account has been successfully reset.",
      },
      VALIDATION: {
        REQUIRED_LOGIN: "Login required!",
        REQUIRED_PASSWORD: "Password must be entered!",
        INVALID_LOGIN: "Invalid login entered!",
        MIN_LOGIN: "Login must be at least 3 characters long!",
        MIN_PASSWORD: "Password must contain at least 3 characters!",
        MAX_LOGIN: "Login must be a maximum of 24 characters!",
        MAX_PASSWORD: "Password must be a maximum of 24 characters!",
      },
    },
    TOOLS: {
      RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          FISH: "Full name",
          LITSEVOY: "FACIAL",
          ETK_NUMBER: "ETK account number",
          ETK_SOATO: "ETK СОАТО",
          COMPANY_NAME: "Company name",
          REGION: "Territory",
          VILLAGE: "Neighborhood",
          ACTION: "Action",
        },
      },
      CHANGING_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATA: "Date",
          NAME: "Name",
          COMPANY_NAME: "Company name",
          NUMBER_ACTS: "Number of acts",
          ACTS_INCREASING_NUMBER: "Acts of increasing numbers",
          ACTS_REDUCTION_NUMBER: "Acts of reduction in numbers",
          TOTAL: "Total",
          APPROVED: "Approved",
          CONTRACT_TERMINATED: "The contract is terminated",
        },
      },
      CASH_PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Date",
          COMPANY_NAME: "Company",
          CHECKSUM: "Checksum",
          TERMINAL: "Terminal",
          CASH: "Cash",
          PACKAGE_SUMM: "Package sum",
          TOTAL: "Total",
          SPECIAL_PACKAGE: "Special Packahe",
          WEBSITE: "Website",
          ANDROID: "Android",
          STATUS: "Status",
          FROM_BANK: "From the bank",
          PACKAGE_DESCRIPTION: "Package explanation",
          USER_FULLNAME: "User full name",
        },
      },
      ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Sana",
          NAME: "Nomi",
          COMPANY_NAME: "Korxona",
          USER_FIO: "Foydalanuvchi FIO",
          CONTROL_COUNT: "Nazorat soni",
          CNT_AKTS: "Aktlar soni",
          SUMMA_AKTS: "Aktlar summasi",
          DEBITOR_AKTS_CNT: "Debitorlik",
          DEBITOR_AKTS_AMOUNT: "Debitorlik (summa)",
          KREDITOR_AKTS_CNT: "Kreditorlik",
          KREDITOR_AKTS_AMOUNT: "Kreditorlik (summa)",
          FIRSTINV_AKTS_CNT: "Birlamchi inven",
          FIRSTINV_AKTS_AMOUNT: "Birlamchi inven (summa)",
          STATUS: "Status",
          FILE_NAME: "Biriktirilgan fayllar",
          STACK_TYPE: "Pachka turi",
          DESCRIPTION: "Izoh",
        },
      },
      PLANS: {
        POPULATION: {
          TABLE_NAME: "Population",
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Name",
            START_DATE: "Start date",
            END_DATE: "End date",
            RATE: "Price",
            ADD_SERVICE: "Additional services",
            SMCH_RATE: "QMCH(m\u00B3)",
            QMCH_RATE: "SMCh(tons)",
            POLIGON_RATE: "Landfill service (m\u00B3)",
            DESCRIPTION: "Description",
          },
        },
        LEGAL_S: {
          TABLE_NAME: "Legal subscribers",
        },
        LEGAL_S_B: {
          TABLE_NAME: "Legal subscribers (Budget)",
        },
        MODAL: {
          PLAN: "Select a category:",
          NAME_UZ: "Name of the tariff:",
          NAME_RU: "Name of the tariff:",
          NAME_CRL: "Name of the tariff:",
          NAME_EN: "Name of the tariff:",
          DESCRIPTION_UZ: "Tariff description:",
          DESCRIPTION_RU: "Tariff description:",
          DESCRIPTION_CRL: "Tariff description:",
          DESCRIPTION_EN: "Tariff description:",
          START_DATE: "Start date:",
          END_DATE: "End date:",
          RATE: "Price:",
          ADD_SERVICE: "Additional services:",
          SMCH_RATE: "QMCH price:",
          QMCH_RATE: "SMCh price:",
          POLIGON_RATE: "Landfill service price:",
          MODAL_TITLE: "Adding a new tariff",
          UPDATE_MODAL: "Editing a  tariff",
          DELETE_MODAL: "Delete tariff",
          DELETE_MODAL_SUBTITLE:
            "Are you sure you want to remove the selected tariff from the system?",
          TOAST_DELETE: "The selected tariff has been successfully deleted!",
          TOAST_SUCCESS: "New tariff added successfully!",
          TOAST_UPDATE: "The selected tariff has been successfully updated!",
        },
      },
      APPEAL: {
        TABLE_HEADERS: {
          ID: "ID",
          ABONENT_FIO: "The petitioner's fullname",
          ABONENT_LICSHET: "Personal account",
          REQUEST_TYPE_NAME: "Request type",
          ABONENT_REQUEST_STATUSES_ID: "Status",
          PHONE: "Phone",
          ABONENT_AREA: "District/Cities",
          ABONENT_COMPANY: "Company name",
          ABONENT_ADRES: "Address",
          EMAIL: "E-mail",
          CHANNEL: "Channel",
          CREATED_DATE: "Date of creation",
          ACCEPTED_DATE: "Date of acceptance",
          EXECUTED_DATE: "Date of execution",
          CANCELED_DATE: "Date of cancellation",
        },
        SELECT: {
          APPLICATIONS_STATUS: "Application status",
          APPLICATIONS_TYPE: "Application type",
          COMPANY_NAME: "Company name",
          NEIGHBORHOOD: "Neighborhood",
        },
      },
      ORG_EMPLOYEES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          COMPANY_NAME: "Company name",
          FIO: "FIO",
          JOB_TITLE: "Job title",
          EMAIL: "Email",
          PHONE: "Phone",
          LOGIN: "Login",
          ATTACHED_FILE: "Attached file",
          STATUS: "Status",
          ADDRESS: "Address",
        },
        JOB_TITLE: {
          TITLE_1: "Control",
          TITLE_2: "Driver",
          TITLE_3: "Inspector",
          TITLE_4: "Operator",
          TITLE_5: "Accountant",
          TITLE_6: "Center Operator",
          TITLE_7: "Center Inspector",
          TITLE_8: "DXSH",
        },
        ACTION: {
          ADD_EMPLOYEES: "Add employees",
          CHANGE_DATA: "Change data",
          CHANGE_PASSWORD: "Change password",
        },
        STATUS: {
          ACTIVE: "Active",
          INACTIVE: "Inactive",
        },
        ORG_EMPLOYEES_MODAL: {},
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DATE: "Date",
          FACIAL: "Facial",
          TRANSACTION_TIME: "Transaction time",
          SUM: "Sum",
          USER_FULLNAME: "User full name",
          TRANSACTION: "Transaction",
          PARTNER_PAYMENT_NAME: "Partner payment name",
          STATUS: "Status",
          NEIGHBORHOOD: "Neighborhood",
          STREET: "Street",
          ACTION: "Action",
        },
      },
      VILLAGES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DISTRICTS: "Districts",
          NAME: "Name",
          INSPECTOR_FULLNAME: "Inspector's fullname ",
          CREATED_BY_USER: "User who created it",
          DATE_OF_CREATION: "Date of creation",
          COMMENT: "Comment",
          ACTION: "Action",
        },
      },
      COURT_WARNING: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Company name",
          NAME: "Name",
          PERSONAL_ACCOUNT: "Personal account",
          ADDRESS: "Address",
          STATUS: "Status",
          WARNING_DATE: "Warning date",
          SUM: "Sum",
          FILE: "File",
        },
        SUBSCRIBERS_TABLE_HEADERS: {
          ID: "ID",
          NAME: "F.I.O",
          PERSONAL_ACCOUNT: "Personal account",
          NEIGHBORHOOD: "Neighborhood",
          STREET: "Street",
          HOME: "Home",
          APARTMENT: "Apartment",
          INDEX: "Index",
        },
        FILTER: {
          FILTER_SEARCH: "Search",
        },
        POSTING_AKT: {
          PERSONAL_ACCOUNT: "Personal account",
          NAME: "Full name",
          ADDRESS: "Address",
          NUMBER_RESIDENTS: "Number of residents",
          WARNING_DATE: "Notice date",
          FILE_ADD: "File attachment",
          PLACEHOLDER_WARNING_AMOUNT: "Warning amount",
          PLACEHOLDER_WARNING_DATE: "Warning date",
          PLACEHOLDER_BASE: "Base",
        },
        SELECT: {
          PLACEHOLDER_COMPANY: "Company name",
          PLACEHOLDER_STATUS: "Status",
          PLACEHOLDER_QUARTER: "Quarter",
          PLACEHOLDER_STREET: "Street",
        },
        INPUT: {
          PLACEHOLDER_HOME: "Home",
          PLACEHOLDER_IND: "Index",
          PLACEHOLDER_APARTMENT: "Apartment",
        },
        SUBSCRIBERS_MODAL: {
          TITLE: {
            SUBSCRIBERS: "Subscribers",
          },
        },
      },
      EMPLOYEES_ACTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Subscriber's full name",
          OPERATION_DATE: "Operation date",
          SUBSCRIBER_NAME: "Full name of the subscriber",
          PERSONAL_ACCOUNT: "Personal account",
          JOB_TYPE: "Job Types",
          COMPANY_NAME: "Company name",
          CHANNEL: "Channel",
          WAS: "Was",
          BECAME: "It became",
          ACTION: "Action",
        },
      },
    },
    ERROR_PAGE: {
      NOT_FOUND_TITLE: "Page not found!",
      RETURN_HOME: "Home",
      SYSTEM_ERROR: "Server error!",
    },
    DATEPICKER: {
      WEEKDAYS_SHORT: ["Mo", "To", "We", "Th", "Fr", "Sa", "Su"],
      MONTHS: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      WEEK: "Week",
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Number of records selected: ",
        ALL: "All",
        SUSPENDED: "Suspended",
        ACTIVE: "Active",
        FILTER: "Filter",
        BY_STATUS: "by Status",
        BY_TYPE: "by Type",
        BUSINESS: "Business",
        INDIVIDUAL: "Individual",
        SEARCH: "Search",
        IN_ALL_FIELDS: "in all fields",
      },
      ECOMMERCE: "eCommerce",
      CUSTOMERS: {
        CUSTOMERS: "Customers",
        CUSTOMERS_LIST: "Customer list",
        NEW_CUSTOMER: "New client",
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: "Client deletion",
          DESCRIPTION: "Are you sure to permanently delete this client?",
          WAIT_DESCRIPTION: "The client is deleting...",
          MESSAGE: "The customer has been deleted",
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: "Remove customers",
          DESCRIPTION:
            "Are you sure to permanently delete the selected clients?",
          WAIT_DESCRIPTION: "Customers delete...",
          MESSAGE: "Selected customers have been deleted",
        },
        UPDATE_STATUS: {
          TITLE: "Status has been updated for selected customers",
          MESSAGE:
            "The status of selected customers has been successfully updated",
        },
        EDIT: {
          UPDATE_MESSAGE: "The client has been updated",
          ADD_MESSAGE: "The client has been created",
        },
      },
    },
    GENERAL: {
      ZONES: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION: "Area",
          COMPANY_NAME: "Company name",
          INSPECTOR_FULLNAME: "Inspector's full name",
          NAME: "Name",
          ABONENT_COUNT: "Number of subscribers",
        },
        SELECT: {
          SELECT_COMPANY: "Select a company",
          SELECT_INSPECTOR: "Select an inspector",
        },
        MODAL: {
          TITLE_SAVE: "Adding a new area",
          TITLE_UPDATE: "Area update",
          TITLE_DELETE: "Delete area",
          REGION: "Region:",
          COMPANY_NAME: "Company name:",
          INSPECTOR_FULLNAME: "Inspector's full name:",
          ABONENT_COUNT: "Number of subscribers:",
          NAME_UZ: "Name (UZ):",
          NAME_RU: "Name (РУ):",
          NAME_CRL: "Name (УЗ):",
          NAME_EN: "Name (EN):",
          CONFIRMATION_MODAL_TEXT: "Do you want to remove the selected area?",
          TOAST_DELETE: "The area has been successfully deleted!",
          TOAST_SUCCESS: "New area added successfully!",
          TOAST_UPDATE: "The area has been successfully updated!",
        },
      },
      RECEIPT_ISSUERS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Company name",
          NAME: "Name",
        },
        MODAL: {
          TITLE_SAVE: "Adding a new receipt issuer",
          TITLE_UPDATE: "Receipt issuer update",
          COMPANY: "Company:",
          NAME_UZ: "Name (UZ):",
          NAME_RU: "Name (РУ):",
          NAME_CRL: "Name (УЗ):",
          NAME_EN: "Name (EN):",
          CONFIRMATION_MODAL_TEXT:
            "Do you want to delete the selected receipt provider?",
          TOAST_DELETE:
            "The selected receipt provider has been successfully deleted!",
          TOAST_SUCCESS: "New receipt provider added successfully!",
          TOAST_UPDATE:
            "The selected receipt provider has been successfully updated!",
        },
      },
    },
    GEOGRAPHY: {
      MODAL_BUTTON: {
        ADD_BUTTON: "Save",
        CANCEL: "Cancel",
      },
      REGIONS: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          NAME: "Name",
          CREATE_DATE: "Date of creation",
        },
        MODAL: {
          MODAL_TITLE: "Add region",
          UPDATE_MODAL: "Edit region",
          DELETE_MODAL: "Delete region",
          DELETE_MODAL_SUBTITLE:
            "Are you sure you want to remove the selected region from your geography?",
          NAME_UZ: "Name (UZ)",
          NAME_RU: "Name (РУ)",
          NAME_CRL: "Name (УЗ)",
          NAME_EN: "Name (EN)",
          MODAL_BUTTONS: {
            CHANGE: "Save",
            CANCEL: "Cancel",
            ADD: "Add",
          },
          TOAST_TITLE: "The selected region has been successfully deleted!",
        },
      },
      DISTRICTS: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION: "Region",
          NAME: "Name",
          CREATOR: "Creator",
          CREATED_AT: "Date of creation",
        },
        MODAL: {
          TITLE_SAVE: "Adding a new district",
          TITLE_UPDATE: "District update",
          TITLE_DELETE: "Delete district",
          REGION: "Region:",
          NAME_UZ: "Name (UZ):",
          NAME_RU: "Name (РУ):",
          NAME_CRL: "Name (УЗ):",
          NAME_EN: "Name (EN):",
          COMMENTARY: "Commentary",
          CONFIRMATION_MODAL_TEXT:
            "Are you sure you want to remove the selected street from your geography?",
          TOAST_DELETE: "Selected area successfully deleted!",
          TOAST_SUCCESS: "New Districts added successfully!",
        },
      },
      VILLAGES: {
        MODAL: {
          TITLE_SAVE: "Adding a new neighborhood",
          TITLE_UPDATE: "Neighborhood update",
          TITLE_DELETE: "Delete neighborhood",
          AREA: "Area",
          NAME_UZ: "Neighborhood name (UZ)",
          NAME_RU: "Neighborhood name (РУ)",
          NAME_CRL: "Neighborhood name (УЗ)",
          NAME_EN: "Neighborhood name (EN)",
          COMMENTARY: "Commentary",
          CONFIRMATION_MODAL_TEXT:
            "Are you sure you want to remove the selected neighborhood from your geography?",
          TOAST_TITLE:
            "The selected region-electracity has been successfully deleted!",
        },
      },
      STREETS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Name",
          COMMENTARY: "Commentary",
        },
        MODAL: {
          TITLE_SAVE: "Adding a new street",
          TITLE_UPDATE: "Street update",
          TITLE_DELETE: "Delete street",
          AREA: "Area",
          NAME_UZ: "Street name (UZ)",
          NAME_RU: "Street name (РУ)",
          NAME_CRL: "Street name (УЗ)",
          NAME_EN: "Street name (EN)",
          COMMENTARY: "Commentary",
          CONFIRMATION_MODAL_TEXT:
            "Are you sure you want to remove the selected street from your geography?",
        },
        TOAST_TEXT: "The selected street has been successfully deleted!",
      },
      SELECT_INPUT: {
        COMPANY_NAME: "Company name",
        INSPECTOR_FULLNAME: "Inspectors's fullname",
      },
    },

    SPRAVOCHNIK: {
      PAYMENT_PARTNERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Наименование",
          USERNAME: "имя пользователя",
          PASSWORD: "пароль",
          ACCESS_TOKEN: "Токен доступа",
        },
        MODAL: {
          TITLE_SAVE: "Добавить партнера",
          TITLE_UPDATE: "Редактировать партнера",
          TITLE_DELETE: "Удалить партнера",
          NAME: "Наименование",
          USERNAME: "имя пользователя",
          PASSWORD: "пароль",
          ACCESS_TOKEN: "Сгенерировать",
          CONFIRMATION_MODAL_TEXT:
            "Вы действительно хотите удалить выбранного партнера?",
          TOAST_DELETE: "Выбранный партнер успешно удален!",
          TOAST_SUCCESS: "Новый партнер добавлен успешно!",
          TOAST_UPDATE: "Партнер успешно обновлен!",
        },
      },
      STATUS_TYPES: {
        ACT_TYPES: {
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Name",
          },
          MODAL: {
            TITLE_SAVE: "Добавить Тип акта",
            TITLE_UPDATE: "Редактировать Тип акта",
            TITLE_DELETE: "Удалить Тип акта",
            NAME: "Наименование",
            USERNAME: "имя пользователя",
            CONFIRMATION_MODAL_TEXT:
              "Вы действительно хотите удалить выбранного акта?",
            MODAL_BUTTONS: {
              CHANGE: "Save",
              CANCEL: "Cancel",
              ADD: "Add",
            },
            TOAST_DELETE: "Выбранный акта успешно удален!",
            TOAST_SUCCESS: "Новый акта добавлен успешно!",
            TOAST_UPDATE: "Акта успешно обновлен!",
          },
        },
      },
    },
  },
};
